import { FormControl, FormControlLabel, IconButton, Radio, RadioGroup } from "@mui/material";
import { styled } from "@mui/material/styles";
import SoftBox from "components/SoftBox";
import { ThemedTrashIcon } from "assets/CXFIcons/Triggers";
import { TextField, StyledSelect } from "layouts/Flow Designer/components/ComponentActionsGenerator/components/StyledComponents";
import { MAX_FLOW_CONFIG_KEY_SIZE, MAX_FLOW_CONFIG_SIZE } from "constants/flowDesigner";
import { CONFIGURATION_TYPES, isValueSizeLimited } from "../../helpers";

const NumberTextField = styled(TextField)({
   "& input[type=number]::-webkit-outer-spin-button": { WebkitAppearance: "none", margin: 0 },
   "& input[type=number]::-webkit-inner-spin-button": { WebkitAppearance: "none", margin: 0 },
   "& input[type=number]": { MozAppearance: "textfield" }
});

const ConfigurationFields = ({ fields, disabled = false, onChange, onRemove, onBlur = () => {}, getFieldState = () => ({}), protectValueSize = false }) => (
   <>
      {fields.map((field, index) => {
         const { keyError = false, keyHelperText = "", typeError = false, valueError = false, valueHelperText = "" } = getFieldState(field, index);

         return (
            <SoftBox key={index} sx={{ display: "grid", p: 1, gap: 2, gridTemplateColumns: "1fr 1fr 1fr auto", alignItems: "start" }}>
               <TextField
                  label="Key"
                  required
                  value={field.key}
                  disabled={disabled}
                  error={keyError}
                  helperText={keyHelperText}
                  inputProps={protectValueSize ? { maxLength: MAX_FLOW_CONFIG_KEY_SIZE } : undefined}
                  onChange={(event) => onChange(index, "key", event.target.value)}
                  onBlur={() => onBlur(index, "key")}
               />
               <StyledSelect
                  placeholder="Select type"
                  label="Type"
                  isRequired
                  isSearchable={false}
                  error={typeError}
                  menuPlacement={fields.length >= 2 && index === fields.length - 1 ? "top" : "bottom"}
                  value={CONFIGURATION_TYPES.find((type) => type.value === field.type)}
                  options={CONFIGURATION_TYPES}
                  isDisabled={disabled}
                  onChange={(option) => onChange(index, "type", option.value)}
                  onBlur={() => onBlur(index, "type")}
                  sx={{ mt: "25px" }}
               />
               {field.type === "boolean" ? (
                  <FormControl sx={{ mt: "25px", ml: 2 }} disabled={disabled}>
                     <RadioGroup row sx={{ columnGap: 2 }} value={field.value === true ? "true" : "false"} onChange={(event) => onChange(index, "value", event.target.value === "true")}>
                        <FormControlLabel value="true" control={<Radio />} label="True" />
                        <FormControlLabel value="false" control={<Radio />} label="False" />
                     </RadioGroup>
                  </FormControl>
               ) : (
                  <NumberTextField
                     label={field.type === "object" ? "JSON Object" : "Value"}
                     required={field.type !== "string"}
                     multiline={field.type === "object"}
                     type={field.type === "number" ? "number" : "text"}
                     disabled={disabled}
                     value={field.value}
                     error={valueError}
                     helperText={valueHelperText}
                     inputProps={protectValueSize && isValueSizeLimited(field) ? { maxLength: MAX_FLOW_CONFIG_SIZE } : undefined}
                     onChange={(event) => onChange(index, "value", field.type === "number" ? (event.target.value === "" ? "" : event.target.valueAsNumber) : event.target.value)}
                     onBlur={() => onBlur(index, "value")}
                  />
               )}
               {!disabled && (
                  <IconButton className="delete-variable-icon" sx={{ mt: "25px" }} onClick={() => onRemove(index)} fontSize="medium">
                     <ThemedTrashIcon width="24px" height="24px" />
                  </IconButton>
               )}
            </SoftBox>
         );
      })}
   </>
);

export default ConfigurationFields;
